<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="form"
            label-width="110px"
            label-position="right"
            :rules="rules"
            :model="listData"
            class="query-form"
            size="mini"
            style="padding: 10px 0 0 20px"
        >
            <el-form-item label="日期: " class="query-form-item" prop="dateArr">
                <el-date-picker
                    v-model="listData.dateArr"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="日耗: " class="query-form-item">
                <el-input-number
                    v-model="objData.daily_budget"
                    style="width: 150px;margin-left:0px;"
                    :min="0.00"
                    label="请输入日耗值"
                ></el-input-number>
            </el-form-item>

            <el-form-item label="bid系数: " class="query-form-item">
                <el-input-number
                    v-model="objData.bid_coefficient"
                    style="width: 150px;margin-left:0px;"
                    :min="1.10"
                    :step="0.1"
                    label="请输入bid系数"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="res: " class="query-form-item" >
                <div>
                    <span>订单数 >=</span>
                    <el-input-number
                        v-model="objData.res_orders"
                        style="width: 150px;margin-left: 10px;"
                        :min="0.00"
                        label="请输入res的订单数"
                    ></el-input-number>
                </div>
                <div style="margin-top:12px;">
                    <span>订单数 <=</span>
                    <el-input-number
                        v-model="objData.res_orders_lt"
                        style="width: 150px;margin-left: 10px;"
                        :min="0.00"
                        label="请输入res的订单数"
                    ></el-input-number>
                </div>
                <div style="margin-top:12px;">
                    <span style="margin-left: 12px;">acos <=</span>
                    <el-input-number
                        v-model="objData.res_acos"
                        style="width: 150px;margin-left: 10px;"
                        :min="0.00"
                        :step="0.1"
                        label="请输入res的acos值"
                    ></el-input-number>
                </div>
            </el-form-item>
            <el-form-item label="phrase-res:" class="query-form-item" >
                <div>
                    <span>订单数 >=</span>
                    <el-input-number
                        v-model="objData.phrase_res_orders"
                        style="width: 150px;margin-left: 10px;"
                        :min="0.00"
                        label="请输入phrase-res的订单数"
                    ></el-input-number>
                </div>
                <div style="margin-top:12px;">
                    <span style="margin-left:12px;">acos <=</span>
                    <el-input-number
                        v-model="objData.phrase_res_acos"
                        style="width: 150px;margin-left: 10px;"
                        :step="0.1"
                        :min="0.00"
                        label="请输入phrase-res订单数"
                    ></el-input-number>
                </div>
            </el-form-item>
            <el-form-item label="per: " class="query-form-item">
                <div>
                    <span>订单数 >=</span>
                    <el-input-number
                        v-model="objData.per_orders"
                        style="width: 150px;margin-left: 10px;"
                        :min="0.00"
                        label="请输入per的订单数"
                    ></el-input-number>
                </div>
                <div style="margin-top:12px;">
                    <span style="margin-left: 12px;">acos <=</span>
                    <el-input-number
                        v-model="objData.per_acos"
                        style="width: 150px;margin-left: 10px;"
                        :min="0.00"
                        :step="0.1"
                        label="请输入per的per-Acos值"
                    ></el-input-number>
                </div>
            </el-form-item>
            <el-form-item label="asin" class="query-form-item">
                <div>
                    <span>订单数 >=</span>
                    <el-input-number
                        v-model="objData.asin_orders"
                        style="width: 150px;margin-left: 10px;"
                        :min="0.00"
                        label="请输入asin的订单数"
                    ></el-input-number>
                </div>
                <div style="margin-top:12px;">
                    <span style="margin-left: 12px;">acos <=</span>
                    <el-input-number
                        v-model="objData.asin_acos"
                        style="width: 150px;margin-left: 10px;"
                        :min="0.00"
                        :step="0.1"
                        label="请输入asin Acos的值"
                    ></el-input-number>
                </div>

                <div style="margin-top:12px;">
                    <span style="margin-left: 12px;">词根</span>
                    <el-input style="width: 200px; margin-left: 10px" clearable v-model="objData.extra_root_words" placeholder="请输入词根，使用逗号分割" size="mini"></el-input>
                </div>
                <div style="margin-top:12px;">
                    <span style="margin-left: 12px;">SKU</span>
                    <el-input style="width: 200px; margin-left: 10px" clearable v-model="objData.setting_skus" placeholder="请输入SKU，使用逗号分割" size="mini"></el-input>
                </div>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/statistics/statistics";

export default {
    data() {
        return {
            files: [],
            dateArr: [],
            rules: {
                dateArr: [
                    {
                        required: true,
                        message: "请选择日期",
                        trigger: "blur"
                    }
                ],
                dailyBudget: [
                    {
                        required: true,
                        message: "请输入日耗值",
                        trigger: "blur"
                    }
                ],
                bidCoefficient: [
                    {
                        required: true,
                        message: "请输入bid系数",
                        trigger: "blur"
                    }
                ]
            },
            listData: {},
            objData: {
                daily_budget: 0.00,
                bid_coefficient: 0.00,
                res_orders: "",
                res_acos: "",
                per_orders: "",
                per_acos: "",
                res_orders_lt: 0,
                phrase_res_orders: 0,
                phrase_res_acos: 0,
                asin_orders: 0,
                asin_acos: 0,
            }
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    mounted() {
        if (this.formData.id) {
            const listData = JSON.parse(JSON.stringify(this.formData));
            listData.dateArr = [
                this.formData.start_date,
                this.formData.end_date
            ];
            this.listData = listData;
            let arr = JSON.parse(this.formData.manual_root);
            let manual_root = "";
            arr.forEach((element, index) => {
                console.log(index);
                manual_root = manual_root + element + "\n";
            });
            this.objData = {
                manual_root: manual_root,
                target_acos: this.formData.target_acos,
                suggest_bidding: this.formData.suggest_bidding
            };
        }
    },
    methods: {
        // 保存信息
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (!this.listData.dateArr.length) {
                        this.$message.warning(`请选择日期`);
                        return;
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: "添加中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    api.add_data_trend({
                        start_date: this.listData.dateArr[0],
                        end_date: this.listData.dateArr[1],
                        daily_budget: this.objData.daily_budget,
                        bid_coefficient: this.objData.bid_coefficient,
                        res_orders: this.objData.res_orders,
                        res_acos: this.objData.res_acos,
                        per_orders: this.objData.per_orders,
                        per_acos: this.objData.per_acos,
                        asin: this.$route.query.asin,
                        state: this.$route.query.state,

                        res_orders_lt: this.objData.res_orders_lt,
                        phrase_res_orders: this.objData.phrase_res_orders,
                        phrase_res_acos: this.objData.phrase_res_acos,
                        asin_orders: this.objData.asin_orders,
                        asin_acos: this.objData.asin_acos,
                        extra_root_words: this.strToArr(this.objData.extra_root_words || ''),
                        setting_skus: this.strToArr(this.objData.setting_skus || ''),
                    }).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: "添加成功",
                                    type: "success"
                                });
                                this.disabled = false;
                                this.handleClose(true);
                            } else {
                                this.disabled = false;
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                        .catch(() => {
                            this.disabled = false;
                        })
                        .finally(() => {
                            loading.close();
                        });
                } else {
                    this.loading = false;
                }
            });
        },
        strToArr(str){
            str = JSON.parse(JSON.stringify(str))
            let arr = str.replaceAll('，', ',').split(',')
            arr = arr.filter(item=>item.trim() !== '')
            arr = arr.map(item=>item.trim())
            return arr
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.listData.dateArr = [];
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
